'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCrosshairs = function FaCrosshairs(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.7 22.9h-2.4q-0.6 0-1-0.5t-0.4-1v-2.8q0-0.6 0.4-1t1-0.5h2.4q-0.7-2.4-2.5-4.2t-4.2-2.5v2.5q0 0.5-0.4 1t-1 0.4h-2.9q-0.6 0-1-0.4t-0.4-1v-2.5q-2.4 0.7-4.2 2.5t-2.5 4.2h2.4q0.6 0 1 0.5t0.4 1v2.8q0 0.6-0.4 1t-1 0.5h-2.4q0.7 2.4 2.5 4.2t4.2 2.5v-2.5q0-0.5 0.4-1t1-0.4h2.9q0.6 0 1 0.4t0.4 1v2.5q2.4-0.7 4.2-2.5t2.5-4.2z m7.6-4.3v2.8q0 0.6-0.4 1t-1 0.5h-3.2q-0.9 3.6-3.5 6.2t-6.2 3.4v3.2q0 0.6-0.4 1t-1 0.4h-2.9q-0.6 0-1-0.4t-0.4-1v-3.2q-3.6-0.8-6.2-3.4t-3.5-6.2h-3.2q-0.6 0-1-0.5t-0.4-1v-2.8q0-0.6 0.4-1t1-0.5h3.2q0.8-3.6 3.5-6.2t6.2-3.4v-3.2q0-0.6 0.4-1t1-0.4h2.9q0.6 0 1 0.4t0.4 1v3.2q3.6 0.8 6.2 3.4t3.5 6.2h3.2q0.5 0 1 0.5t0.4 1z' })
        )
    );
};

exports.default = FaCrosshairs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/crosshairs.js
// module id = 689
// module chunks = 168707334958949